import React from "react";
import { ParallaxLayer } from "@react-spring/parallax";
import UFOImage from "../../../assets/info/UFO_GRP.webp";
import SpaceGas1 from "../../../assets/info/SpaceGas-1.webp";
import SpaceGas2 from "../../../assets/info/SpaceGas-2.webp";
import SpaceGas3 from "../../../assets/info/SpaceGas-3.webp";
import SpaceGas4 from "../../../assets/info/SpaceGas-4.webp";
import SpaceGas5 from "../../../assets/info/SpaceGas-5.webp";
import SpaceGasDark from "../../../assets/info/SpaceGas-Dark.webp";
import SpaceGasMain from "../../../assets/info/SpaceGas.webp";
import Cloud1 from "../../../assets/info/cloud1.webp";
import Cloud2 from "../../../assets/info/cloud2.webp";
import Cloud3 from "../../../assets/info/cloud3.webp";
import Cloud4 from "../../../assets/info/cloud4.webp";
import Star1 from "../../../assets/info/Stars-1.webp";
import Star2 from "../../../assets/info/Stars.webp";
import { getAboutLayerSpeed } from "./utilz/layerSpeeds";

interface AboutLayersProps {
	offset: number;
	isFirstVisit: boolean;
}

export const AboutLayers: React.FC<AboutLayersProps> = ({ offset, isFirstVisit }) => (
	<>
		{/* SpaceGas stack */}
		<ParallaxLayer
			key={`About-SpaceGas-${offset}`}
			offset={0}
			style={{ zIndex: 11, overflow: "hidden" }}
		>
			{[SpaceGas1, SpaceGas2, SpaceGas3, SpaceGas4, SpaceGas5, SpaceGasDark, SpaceGasMain].map((img, i) => (
				<div
					className="space-gas"
					key={i}
				>
					<img
						src={img}
						alt={`Space Gas ${i + 1}`}
					/>
				</div>
			))}
		</ParallaxLayer>

		{/* Back clouds */}
		<ParallaxLayer
			key={`About-Cloud_back-${offset}-${isFirstVisit}`}
			offset={0}
			speed={isFirstVisit ? getAboutLayerSpeed("cloudsBack") : 0}
			style={{ zIndex: 13, overflow: "hidden" }}
		>
			<div className="clouds-back">
				<img
					src={Cloud2}
					alt="Cloud 2"
				/>
			</div>
			<div className="clouds-back3">
				<img
					src={Cloud3}
					alt="Cloud 3"
				/>
			</div>
			<div className="clouds-back">
				<img
					src={Cloud4}
					alt="Cloud 4"
				/>
			</div>
		</ParallaxLayer>

		{/* Stars */}
		<ParallaxLayer
			key={`About-Stars-${offset}-${isFirstVisit}`}
			offset={0}
			speed={getAboutLayerSpeed("stars")}
			style={{ zIndex: 12, overflow: "hidden" }}
		>
			<div className="stars">
				<img
					src={Star1}
					alt="Star 1"
				/>
			</div>
		</ParallaxLayer>
		<ParallaxLayer
			key={`About-Stars2-${offset}-${isFirstVisit}`}
			offset={0}
			speed={getAboutLayerSpeed("stars2")}
			style={{ zIndex: 12, overflow: "hidden" }}
		>
			<div className="stars">
				<img
					src={Star2}
					alt="Star 2"
				/>
			</div>
		</ParallaxLayer>

		{/* UFO */}
		<ParallaxLayer
			key={`About-UFO-${offset}`}
			offset={0}
			style={{ zIndex: 14, overflow: "hidden" }}
		>
			<div className="ufo">
				<img
					src={UFOImage}
					alt="Bonk UFO"
				/>
			</div>
		</ParallaxLayer>

		{/* Front cloud */}
		<ParallaxLayer
			key={`About-Cloud_front-${offset}`}
			offset={0}
			style={{ zIndex: 15, overflow: "hidden" }}
		>
			<div className="cloud-front-1">
				<img
					src={Cloud1}
					alt="Cloud 1"
				/>
			</div>
		</ParallaxLayer>
	</>
);
